import { useSelector } from "react-redux";
import { ChevronDown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useReportFilters } from "../../contexts/ReportFiltersContext";

const ShopFilter = () => {
  const shops = useSelector((state) => state.shops);
  const { shopId, setShopId } = useReportFilters();
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  useEffect(() => {
    if (!shopId && shops?.data?.length > 0) {
      setShopId(shops.data[0]._id);
    }
  }, [shopId, shops?.data, setShopId]);

  const current = shops?.data?.find((s) => s._id === shopId);

  return (
    <div className="relative" ref={boxRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-md text-sm hover:bg-gray-50 min-w-[160px]"
      >
        {current?.avatar && (
          <img
            src={current.avatar}
            alt=""
            className="w-5 h-5 rounded-full object-cover"
          />
        )}
        <span className="flex-1 truncate text-left">
          {current?.name || "Chọn Zalo"}
        </span>
        <ChevronDown size={14} className="text-gray-400" />
      </button>
      {open && (
        <div className="absolute left-0 top-full mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50 max-h-80 overflow-y-auto">
          {(shops?.data || []).map((shop) => (
            <button
              key={shop._id}
              type="button"
              onClick={() => {
                setShopId(shop._id);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-gray-50 ${
                shop._id === shopId ? "bg-blue-50 text-blue-700" : ""
              }`}
            >
              {shop.avatar && (
                <img
                  src={shop.avatar}
                  alt=""
                  className="w-5 h-5 rounded-full object-cover"
                />
              )}
              <span className="truncate">{shop.name}</span>
              <span
                className={`ml-auto w-2 h-2 rounded-full ${
                  shop.isLogin ? "bg-green-500" : "bg-gray-300"
                }`}
              />
            </button>
          ))}
          {(!shops?.data || shops.data.length === 0) && (
            <div className="px-3 py-2 text-sm text-gray-500">Chưa có Zalo</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ShopFilter;
